<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/localSeo/reviews']"
        >
          Reviews
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>
</div>
